'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('SgElementDialogCtrl', SgElementDialogCtrl);

  /**
   * locals bound to controller:
   * @see sgElementForm
   *
   * @controller SgElementDialogCtrl
   * @param scope {Object} - use $scope.$new() to be able to access parent scope.
   *                              used for elementsNav: both for callbacks and scope.broadcasts
   *                              I have investigated the possibility to refactor this so we dont have to use scope,
   *                              but it's not viable do to having to inject rootScope for communication with dialog
   *                              In the future, refactoring to a component might be worthwhile.
   * @param locals.title {String} - Dialog title
   * @param locals.element {Object} - The libElement or the project element. Use empty object is starting from scratch
   * @param locals.modules {Object[]} - The modules that can be selected for element.moduleId.
   *                            Should include submodules as child of each module
   * @param [locals.constructions] {Object[]} - The constructions available to pick from
   * @param locals.constants {Object[]} - constants
   * @param locals.showElementsNav {Boolean} - show up/down carets to step through the elements
   * @param locals.language {String} - Language to use in editor spellchecks.
   *
   * @param locals.projectLevel {Number} - sgElementForm.projectLevel
   * @param locals.appSection {Enum} - sgElementForm.appSection
   * @param locals.action {Enum} - sgElementForm.action
   * @param [local.disabledFields] {String[]} - sgElementForm.disabledFields
   * @param [local.hiddenFields] {String[]} - sgElementForm.hiddenFields
   *
   * @example LibElementCtrl.openLibElementDialog
   * */
  SgElementDialogCtrl.$inject = ['$scope', 'Project', 'ProjectBusinessService', 'Auth', 'Labels',
    'LibElement', 'errorMessageService', '$mdDialog', 'EditorConfig', 'Constants'];

  function SgElementDialogCtrl ($scope, ProjectAPI, ProjectBusinessService, Auth, Labels,
    LibElement, errorMessageService, $mdDialog, EditorConfig, Constants) {
    const vm = this;

    vm.constants = Constants.getAll();

    //
    // Initialization
    //
    vm.$onInit = function () {
      vm.LABELS = Labels;
      vm.addanother = false;
      vm.editorOptions = new EditorConfig({
        language: vm.language || 'nl'
      });

      if (!vm.element) {
        vm.element = {
          hasInputInstruction: false,
          appliesToFases: [1, 2, 3, 4],
          isPresentInPvEDocument: true,
        };
      }

      if (vm.action === 'copy') {
        delete vm.element._id;
        vm.element.name = vm.element.name + ' (' + Labels.getLabel('copy2') + ')';
      }
    };

    /**
     * On receiving new element.
     * 
     * @param {object} e event.
     * @param {object} element New element object.
     */
    $scope.$on('newElement', (e, element) => {
      vm.element = angular.copy(element);
    });

    //
    // User interactions
    //
    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.submit = function () {
      setValuesForSubmit();
      addComment();

      vm.element = angular.copy(vm.element);
      vm.element.action = vm.action;
      // prevent circular json
      if (vm.element.submodule && vm.element.submodule.elements) {
        delete vm.element.submodule.elements;
        delete vm.element.module.submodules;
      }

      // backwards compatibility
      if (vm.saveFunction) {
        vm.saveFunction(vm.element).then((res) => {
          if (vm.addanother) {
            resetForm();
          } else {
            $mdDialog.hide(res.elements);
          }
        })
      }
      else if (vm.element._id) {
        updateElement();
      } else {
        createElement();
      }
    };

    //
    // Helpers
    //
    const setValuesForSubmit = () => {
      vm.element.values = [];
      const {values, qualityLevel} = vm.element;
      let qualityLevelValue = '';

      vm.constants.QUALITY_LEVELS.forEach((level) => {

        qualityLevelValue = qualityLevel[level.value] ? qualityLevel[level.value] : qualityLevel.all;

        const value = vm.element.hasMultipleQualityLevels !== true && qualityLevel.minimum
          ? qualityLevel.all : qualityLevelValue;

        values.push({
          quality: level.value,
          value
        });

      });
    };

    const addComment = () => {
      if (vm.element.comment) {
        if (!vm.element.comments) {
          vm.element.comments = [];
        }

        vm.element.comments.push({
          userId: Auth.getCurrentUser()._id,
          text: vm.element.comment,
        });
      }
    };

    function updateElement () {
      LibElement
        .patch({_id: vm.element._id, element: vm.element}).$promise
        .then((res) => {
          $mdDialog.hide(res.elements);
          errorMessageService.showSuccess(Labels.getLabel('templatespecificationedited'));
        })
        .catch((err) => {
          errorMessageService.showError(err);
        });
    }

    function createElement () {
      LibElement
        .save({element: vm.element}).$promise
        .then((res) => {
          if (vm.addanother) {
            resetForm();
          } else {
            $mdDialog.hide(res.elements);
          }
          errorMessageService.showSuccess(Labels.getLabel('templatespecificationcreated'));
        })
        .catch((err) => {
          errorMessageService.showError(err);
        });
    }

    function resetForm () {
      vm.element.name = '';
      vm.element.comment = '';
      vm.element.inputInstruction = '';
      vm.element.qualityLevel.all = '';
      // vm.constants.QUALITY_LEVELS.forEach((level) => {
      //   vm.element.qualityLevel[level.value] = '';
      // });
      vm.form.$setPristine(true);
      vm.form.$setUntouched(true);
    }
  }
})();
